function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddMediaFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.014 3h-4.778c-.757 0-1.45.428-1.789 1.105L10 7H4a2 2 0 00-2 2v18a2 2 0 002 2h24a2 2 0 002-2V14.014h-2V27H4V9h7.236l2-3.996h4.778V3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10a7.5 7.5 0 00-7.5 7.5c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5A7.5 7.5 0 0016 10zm0 13a5.506 5.506 0 01-5.5-5.5c0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5S19.033 23 16 23zM26 6V2h-2v4h-4v2h4v4h2V8h4V6h-4z",
    fill: props.color
  }));
}

export default SvgIconAddMediaFilled;